import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.616 12.22a11.05 11.05 0 0 0-5.698 5.141h3.526a14.2 14.2 0 0 1 2.172-5.14Zm-2.718 10.218c0-1.132.081-2.263.242-3.384h-3.935a10.92 10.92 0 0 0 0 6.769h3.935a24 24 0 0 1-.242-3.385m11.253-5.077c-.91-3.67-2.74-5.923-4.484-5.923s-3.577 2.253-4.485 5.923h8.97Zm-9.561 5.077a22.5 22.5 0 0 0 .249 3.385h9.656a23.2 23.2 0 0 0 0-6.77h-9.656a22.5 22.5 0 0 0-.25 3.385Zm-4.672 5.077a11.05 11.05 0 0 0 5.698 5.14 14.2 14.2 0 0 1-2.172-5.14zm16.518-5.077a24 24 0 0 1-.242 3.385h3.935c.717-2.2.717-4.57 0-6.77h-3.935q.24 1.685.242 3.385" }, null, -1),
    _createElementVNode("path", { d: "M22.667 2.13a20.308 20.308 0 1 0 20.307 20.308A20.33 20.33 0 0 0 22.668 2.131Zm0 33a12.692 12.692 0 1 1 12.692-12.692 12.706 12.706 0 0 1-12.692 12.693Z" }, null, -1),
    _createElementVNode("path", {
      fill: "#2C2D33",
      d: "M18.182 27.515c.911 3.67 2.74 5.923 4.485 5.923 1.744 0 3.576-2.252 4.484-5.923zm8.535-15.295a14.2 14.2 0 0 1 2.172 5.141h3.526a11.05 11.05 0 0 0-5.698-5.14Zm0 20.436a11.05 11.05 0 0 0 5.698-5.14H28.89a14.2 14.2 0 0 1-2.172 5.14Z"
    }, null, -1)
  ])))
}
export default { render: render }